import StepView from '../../atoms/display/StepView'
import Avatar from '../../atoms/display/Avatar'
import { RelatedUser } from '../../../types/User'

type Props = {
  users: RelatedUser[]
  activeStep?: number
}

export default function AvatarUserStepper({ users, activeStep }: Props) {
  return (
    <StepView
      steps={users.map((user, index) => ({
        id: user.id ?? 'person',
        icon: <Avatar alt={user.name} url={user.icon} />,
        label: user.name ?? '担当者',
        badge: index === activeStep,
      }))}
      activeStep={activeStep}
    />
  )
}
